import React, { useEffect } from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';
import PerformanceMonitor from './components/PerformanceMonitor';
import Navbar from './components/Navbar';
import Hero from "./components/Hero";
import Services from './components/Services';
import About from "./components/About";
import Contact from "./components/Contact";
import Portfolio from "./components/Portfolio";
import CookieConsent from './components/CookieConsent';
import { initGA, trackPageView, trackScrollDepth } from './utils/analytics';
import './i18n';

function App() {
  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname, document.title);
    trackScrollDepth();
  }, []);

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-slate-950">
        <SEO />
        <PerformanceMonitor />
        <Navbar />
        <main>
          <Hero />
          <Services />
          <About />
          <Portfolio />
          <Contact />
        </main>
        <CookieConsent />
      </div>
    </HelmetProvider>
  );
}

export default App;
